export const isNumber = (value: string | null | undefined): boolean => {
  if (value === null) return false;
  if (typeof value === 'undefined') return false;
  return !isNaN(parseInt(value));
};
